import {format}  from "timeago.js"

function Dhaqaaq({qof}){
    return(
    <div className="qof" key={qof.id}>
        <div className="qof_xaraf">
            <p>e</p>
        </div>
        <div className="massage">
            <p>
                #ID:{qof.id.slice(0, 7).toUpperCase()} {qof.email ? `@${qof.email.slice(0, 7).toUpperCase()}` :"Bila Magac"}
            </p>
            <span>Waxa Uu Xisaabiyay<span className="cadad">{qof.Xadiga}</span> Oo {qof.Nooca} Ah</span>
        </div>
        <div className="jawaab_dhaq">
            <p>
                <i className="fa-solid fa-clock"></i>
            </p>
            <div className="tariikh">
                <p className="t_wakhti">{format(qof.CreatedAt)}</p>
            </div>
        </div>
    </div>
    )
}


export default Dhaqaaq